import React from 'react'
import { useParams } from 'react-router-dom';
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { InscripcionClientesLang } from './Lang/InscripcionClientesLang';

const FinLinkInscripciónClientes = () => {
    const params = useParams();
    const Token = params.Token;
    const lang = params.lang !== "null" ? params.lang : "es";


    return (
        <div className=''>
            <div className='d-flex' style={{ width: '80vw', justifyContent: 'center', alignItems: 'center' }}>
                <div className='header'>
                    <img
                        src={`${process.env.REACT_APP_Logo_Primario_H}`}
                        alt="Imagen"
                        className="logo"
                        style={{ height: 200 }}
                    />
                </div>
                <div className='text-center'>
                    <h2>
                        {getLabel(InscripcionClientesLang, 'InscripcionFinalizada', lang)}
                    </h2>
                    <h4>
                        {getLabel(InscripcionClientesLang, 'dialogFinal', lang)}
                    </h4>

                </div>

            </div>


        </div>
    )
}

export default FinLinkInscripciónClientes